var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isLoading
      ? _c("div", { staticClass: "global-loading-overlay" }, [_vm._m(0)])
      : _vm._e(),
    _vm._v(" "),
    _vm.showFilter
      ? _c(
          "div",
          { staticClass: "row mt-3" },
          [
            _c("h4", { staticClass: "mb-3" }, [_vm._v("Pencarian Data")]),
            _vm._v(" "),
            _vm._l(_vm.filterConfigs, function (filterConfig, index) {
              return _c("div", { key: index, class: filterConfig.colClass }, [
                _c("div", { staticClass: "mb-3 row" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-sm-4 col-form-label text-end",
                      attrs: { for: filterConfig.id },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(filterConfig.label) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !filterConfig.component
                    ? _c(
                        "div",
                        { staticClass: "col-sm-8" },
                        [
                          _c(
                            filterConfig.component || "input",
                            _vm._b(
                              {
                                tag: "component",
                                staticClass: "form-control",
                                attrs: {
                                  type: filterConfig.type || "text",
                                  name: filterConfig.id,
                                  id: filterConfig.id,
                                  value: _vm.filter[filterConfig.field],
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateFilter(
                                      filterConfig.field,
                                      $event
                                    )
                                  },
                                },
                              },
                              "component",
                              filterConfig.props || {},
                              false
                            )
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "col-sm-8" },
                        [
                          _c("DropDownYear", {
                            attrs: {
                              modelValue: _vm.filter[filterConfig.field],
                            },
                            on: {
                              "update:modelValue": function ($event) {
                                return _vm.updateFilter(
                                  filterConfig.field,
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c("div", { staticClass: "mb-3" }, [
                _c(
                  "div",
                  { staticClass: "d-flex gap-1 align-items-center flex-wrap" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-danger",
                        attrs: { type: "button", disabled: _vm.isLoading },
                        on: { click: _vm.resetFilters },
                      },
                      [
                        _c("i", { staticClass: "fa fa-refresh" }),
                        _vm._v(
                          "\n                        Reset\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-primary",
                        attrs: { type: "button", disabled: _vm.isLoading },
                        on: { click: _vm.refreshTable },
                      },
                      [
                        _c("i", {
                          staticClass: "fa",
                          class: _vm.isLoading
                            ? "fa-spinner fa-spin"
                            : "fa-search",
                        }),
                        _vm._v(
                          "\n\n                        " +
                            _vm._s(_vm.isLoading ? "Memuat..." : "Cari") +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-success",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.downloadExcel },
                      },
                      [
                        _c("i", { staticClass: "fa fa-file-excel-o" }),
                        _vm._v(" Download Excel\n                    "),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card mb-3" }, [
      _c(
        "div",
        { staticClass: "card-header text-white", class: _vm.headerClass },
        [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-body table-card-body" }, [
        _c("div", { staticClass: "datatable-responsive" }, [
          _c("div", { attrs: { id: _vm.tableId } }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "global-loading-box" }, [
      _c("div", { staticClass: "global-spinner" }),
      _vm._v(" "),
      _c("div", { staticClass: "global-loading-text" }, [
        _vm._v("Memuat data..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }